'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = require('./lib/index');
module.exports = require('./lib/index');